export default "__VITE_ASSET__BbSXMN8y__"